import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow\"><path d=\"M526.336 1016.32l296.96-314.88c9.728-14.848-0.512-34.816-18.944-34.816h-131.072V354.816h129.024c17.92 0 28.16-19.456 18.432-34.304L526.336 7.68c-8.192-10.24-20.992-10.24-29.184 0L203.264 320.512c-9.728 14.848 0.512 34.304 18.432 34.304h129.024v311.808H219.648c-17.92 0-28.16 19.968-18.944 34.816l296.448 314.88c8.192 10.24 20.992 10.24 29.184 0z\" p-id=\"11357\" fill=\"#1890ff\" stroke=\"black\" stroke-width=\"20px\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol